document.addEventListener("DOMContentLoaded", function () {
  let current_country_code = $("body").attr("data-country-code");
  const firstLetterCap = current_country_code.toUpperCase();
  console.log('firstLetterCap: ' + firstLetterCap);

  if (sessionStorage.getItem("languageSelectedManually") === "true") {
    return;
  }

  let countryData = localStorage.getItem("cachedCountryData");
  var countryCode;

  if (countryData) {
    const parsedData = JSON.parse(countryData);
    countryCode = (parsedData.country_code === 'KR' || parsedData.country_code === 'KO') ? 'KO' : parsedData.country_code;
  } else {
    $.ajax({
      url: "https://ipapi.co/json/",
      method: "GET",
      dataType: "json",
      success: function (data) {
        console.log(data);
        localStorage.setItem("cachedCountryData", JSON.stringify(data));
        countryCode = data.country_code;

        handleRedirect(countryCode, firstLetterCap);
      },
      error: function (xhr, status, error) {
        console.error("IPinfo error:", error);
      }
    });
    return;
  }

  handleRedirect(countryCode, firstLetterCap);
});

function handleRedirect(countryCode, firstLetterCap) {
  if (countryCode === "JP") {
    countryCode = "JA";
  }

  const supportedLanguages = ["JA", "FR", "DE", "ES", "NO", "KO"];
  let redirectURL = null;

  if (countryCode !== firstLetterCap) {
    switch (countryCode) {
      case "JA": redirectURL = "https://www.vr-wave.store/ja/"; break;
      case "FR": redirectURL = "https://www.vr-wave.store/fr/"; break;
      case "DE": redirectURL = "https://www.vr-wave.store/de/"; break;
      case "ES": redirectURL = "https://www.vr-wave.store/es/"; break;
      case "NO": redirectURL = "https://www.vr-wave.store/no/"; break;
      case "KO": redirectURL = "https://www.vr-wave.store/ko/"; break;
      default:
        if (localStorage.getItem("redirectedOnce") === "true") return;
        localStorage.setItem("redirectedOnce", "true");
        redirectURL = "https://www.vr-wave.store/";
        break;
    }
  }

  if (supportedLanguages.includes(countryCode)) {
    localStorage.removeItem("redirectedOnce");
  }

  if (redirectURL) {
    window.location.href = redirectURL;
  }
}

$(".lang_tab.ml_lang_texts_long").on("click", function () {
  const value = $(this).attr("value");
  console.log("Clicked value:", value);
  sessionStorage.setItem("languageSelectedManually", "true");
});